"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CustomerCache {
    constructor(cache, logger, networkFirstStrategy) {
        this.getNote = async (customerId, getRequest) => this.networkFirstStrategy.get(this.noteKey(customerId), getRequest);
        this.setNote = (customerId, note) => this.cache.setObject(this.noteKey(customerId), note).asPromise();
        this.noteKey = (customerId) => {
            return `${CustomerCache.NOTE_KEY_PREFIX}.${customerId}`;
        };
        this.getCustomers = (getRequest) => {
            return this.networkFirstStrategy.get(CustomerCache.CUSTOMERS_KEY_PREFIX, getRequest, []);
        };
        this.setCustomers = async (customers) => {
            const customersById = new Map();
            customers.forEach((customer) => {
                customersById.set(customer.id, customer);
            });
            await this.cache
                .setArray(CustomerCache.CUSTOMERS_KEY_PREFIX, customers)
                .asPromise();
        };
        this.setCustomer = async (customer) => {
            const customers = (await this.cache
                .getArray(CustomerCache.CUSTOMERS_KEY_PREFIX)
                .withDefault(null)
                .asPromise());
            if (customers !== null) {
                const customerListItemIndex = customers.indexOf(customers.find(({ id }) => customer.id === id));
                customers[customerListItemIndex] = customer;
                await this.cache
                    .setArray(CustomerCache.CUSTOMERS_KEY_PREFIX, customers)
                    .asPromise();
            }
            else {
                this.logger.warn(`Customer of id ${customer.id} was not found in cache, yet we tried to update it`);
            }
            this.logger.log(`Customer "${customer.id}" Cache Updated`);
        };
        this.getLatestIntakeInfo = async (customerId, getRequest) => this.networkFirstStrategy.get(this.intakeInfoKey(customerId), getRequest);
        this.intakeInfoKey = (customerId) => {
            return `${CustomerCache.INTAKE_INFO_KEY_PREFIX}.${customerId}`;
        };
        this.getCalorieBudget = async (customerId, getRequest) => this.networkFirstStrategy.get(this.calorieBudgetKey(customerId), getRequest);
        this.setCalorieBudget = (customerId, calorieBudget) => {
            return this.cache
                .setObject(this.calorieBudgetKey(customerId), calorieBudget)
                .asPromise();
        };
        this.calorieBudgetKey = (customerId) => {
            return `${CustomerCache.CALORIE_BUDGET_KEY_PREFIX}.${customerId}`;
        };
        this.setNotifications = async (customerId, notifications) => {
            const customers = await this.getCustomers();
            const customer = customers.find((c) => c.id === customerId);
            customer.notifications = notifications;
            await this.setCustomer(customer);
            try {
                const customersList = await this.getCustomers();
                const customersListItem = customersList.find(({ id }) => customerId === id);
                customersListItem.notifications = notifications;
                await this.setCustomers(customersList);
            }
            catch (e) {
                // ignored
            }
        };
        this.cache = cache;
        this.logger = logger;
        this.networkFirstStrategy = networkFirstStrategy;
    }
}
CustomerCache.NOTE_KEY_PREFIX = "CustomerCache.NOTE";
CustomerCache.CUSTOMERS_KEY_PREFIX = "CustomerCache.CUSTOMERS.V2";
CustomerCache.INTAKE_INFO_KEY_PREFIX = "CustomerCache.INTAKE_INFO";
CustomerCache.CALORIE_BUDGET_KEY_PREFIX = "CustomerCache.CALORIE_BUDGET";
exports.default = CustomerCache;
//# sourceMappingURL=CustomerCache.js.map